import type { SVGProps } from 'react';

const ContentPrecisionIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="60"
    height="60"
    viewBox="0 0 60 60"
    fill="none"
    {...props}
  >
    <g clipPath="url(#clip0_174_41206)">
      <path
        d="M56.5738 6.93359V6.93359C57.85 6.93359 58.8846 7.96815 58.8846 9.24435V39.6825C58.8846 45.2054 54.4074 49.6825 48.8846 49.6825H11.1157C5.59288 49.6825 1.11572 45.2054 1.11572 39.6825V16.9336C1.11572 11.4108 5.59288 6.93359 11.1157 6.93359H17.8687"
        stroke="#112A55"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M41.5546 49.6797H18.447V57.7673H41.5546V49.6797Z"
        stroke="#112A55"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M9.73706 58.0117H50.2641"
        stroke="#112A55"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M46.0552 18.8253C46.6997 20.5625 47.0519 22.4416 47.0519 24.403C47.0519 33.2594 39.8724 40.4389 31.0161 40.4389C22.1597 40.4389 14.9802 33.2594 14.9802 24.403C14.9802 15.5467 22.1597 8.36719 31.0161 8.36719C32.9775 8.36719 34.8566 8.71933 36.5937 9.36384"
        stroke="#2563EB"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.1062 21.6133C25.6889 22.4673 24.741 24.0212 24.741 25.7965C24.741 28.492 26.926 30.677 29.6214 30.677C31.3968 30.677 32.9507 29.7291 33.8047 28.3118"
        stroke="#2563EB"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.5853 26.6221L41.9104 14.2971M41.9104 14.2971V8.5502C41.9104 7.81056 42.2042 7.10121 42.7272 6.5782L45.8544 3.45101C47.1279 2.1775 49.3054 3.07946 49.3054 4.88047V4.88047C49.3054 5.99694 50.2105 6.90203 51.327 6.90203V6.90203C53.128 6.90203 54.0299 9.07953 52.7564 10.353L49.6292 13.4802C49.1062 14.0032 48.3969 14.2971 47.6572 14.2971H41.9104Z"
        stroke="#2563EB"
        strokeWidth="2"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_174_41206">
        <rect width="60" height="60" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default ContentPrecisionIcon;
